import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import SelfWash from './pages/SelfWash';
import SelfDry from './pages/SelfDry';
import Pricing from './pages/Pricing';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';
import "./i18n"
import './App.css';

import { useEffect } from 'react';

function App() {

    return (
      <Router> 
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/self-wash" element={<SelfWash />} />
          <Route path="/self-dry" element={<SelfDry />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </Router>
    );
}

export default App;